// Global image preview state (vanilla JS approach)
if (!window.imagePreviewState) {
  window.imagePreviewState = {
    visible: false,
    currentIndex: 0,
    images: [],
    blockIndex: null,
  };
}

// Custom image preview handlers
const openImagePreview = (images, startIndex = 0, currentBlockIndex) => {
  window.imagePreviewState = {
    visible: true,
    currentIndex: startIndex,
    images: images,
    blockIndex: currentBlockIndex,
  };
  renderImagePreview();
};

const closeImagePreview = () => {
  window.imagePreviewState = {
    visible: false,
    currentIndex: 0,
    images: [],
    blockIndex: null,
  };
  removeImagePreview();
};

const nextImage = () => {
  if (window.imagePreviewState.images.length > 1) {
    window.imagePreviewState.currentIndex =
      (window.imagePreviewState.currentIndex + 1) % window.imagePreviewState.images.length;
    renderImagePreview();
  }
};

const prevImage = () => {
  if (window.imagePreviewState.images.length > 1) {
    window.imagePreviewState.currentIndex =
      window.imagePreviewState.currentIndex === 0
        ? window.imagePreviewState.images.length - 1
        : window.imagePreviewState.currentIndex - 1;
    renderImagePreview();
  }
};

const goToImage = (index) => {
  if (
    window.imagePreviewState.images.length > 1 &&
    index >= 0 &&
    index < window.imagePreviewState.images.length
  ) {
    window.imagePreviewState.currentIndex = index;
    renderImagePreview();
  }
};

const handleKeyDown = (e) => {
  if (!window.imagePreviewState.visible) return;

  switch (e.key) {
    case 'Escape':
      closeImagePreview();
      break;
    case 'ArrowRight':
      nextImage();
      break;
    case 'ArrowLeft':
      prevImage();
      break;
    default:
      break;
  }
};

// Add keyboard event listener (only once)
if (!window.imagePreviewInitialized) {
  document.addEventListener('keydown', handleKeyDown);
  window.imagePreviewInitialized = true;
}

// JS functions to render and remove image preview
const renderImagePreview = () => {
  removeImagePreview(); // Remove existing modal first

  if (!window.imagePreviewState.visible || window.imagePreviewState.images.length === 0) {
    return;
  }

  const currentImage = window.imagePreviewState.images[window.imagePreviewState.currentIndex];
  const hasMultipleImages = window.imagePreviewState.images.length > 1;

  const modalHTML = `
    <div class="confirm-modal custom-image-preview-modal" id="custom-image-preview-modal">
      <div class="modal-overlay" onclick="window.closeImagePreview()"></div>
      <button class="close-button" onclick="window.closeImagePreview()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          CLOSE
        </button>
                  ${
                    hasMultipleImages
                      ? `
          <button class="nav-button prev-button" onclick="window.prevImage()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button class="nav-button next-button" onclick="window.nextImage()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        `
                      : ''
                  }
                  ${
                    hasMultipleImages
                      ? `
          <div class="image-dots">
            ${window.imagePreviewState.images
              .map(
                (_, index) => `
              <div class="dot ${index === window.imagePreviewState.currentIndex ? 'active' : ''}" 
                    onclick="window.goToImage(${index})"></div>
            `
              )
              .join('')}
          </div>
        `
                      : ''
                  }
      <div class="modal-content">
        <div class="image-container">
          <img src="${currentImage?.url}" alt="${
    currentImage?.alt || 'Preview image'
  }" class="preview-image" loading="lazy" />
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // Add global functions to window
  window.closeImagePreview = closeImagePreview;
  window.nextImage = nextImage;
  window.prevImage = prevImage;
  window.goToImage = goToImage;
};

const removeImagePreview = () => {
  const existingModal = document.getElementById('custom-image-preview-modal');
  if (existingModal) {
    existingModal.remove();
  }
};

export { openImagePreview, renderImagePreview };
